import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import {
  BEGIN, CREATE, FAILED, SUCCESSFUL, UPDATE,
} from '../../configs/actionNames';
import { AUTHORIZED_MODULE, SETTINGS_MODULE } from '../../configs/moduleNames';

export const AUTHORIZED_REGISTRATION = '_AUTHORIZED_REGISTRATION';
export const AUTHORIZED_LOGIN = '_AUTHORIZED_LOGIN';
export const AUTHORIZED_LOGOUT = '_AUTHORIZED_LOGOUT';
export const AUTHORIZED_CHECK = '_AUTHORIZED_CHECK';
export const FORGOT_PASSWORD = '_FORGOT_PASSWORD';
export const REFRESH_KEY_CLOAK = '_REFRESH_KEY_CLOAK';
export const LOAD_NOTIFICATION = '_LOAD_NOTIFICATION';

export const LOAD_TRANSPORT_LIST = '_LOAD_TRANSPORT_LIST';
export const LOAD_REPRESENTATIVE_LIST = '_LOAD_REPRESENTATIVE_LIST';
export const LOAD_ORGANIZATION_LIST = '_LOAD_ORGANIZATION_LIST';
export const LOAD_NOTIFICATION_TYPES = '_LOAD_NOTIFICATION_TYPES';
export const DELETE_NOTIFICATION = '_DELETE_NOTIFICATION';
export const MARK_ALL = '_MARK_ALL';
export const GET_ESIA_URL = '_GET_ESIA_URL';
export const AUTHORIZED_ESIA_LOGIN = '_AUTHORIZED_ESIA_LOGIN';
export const AUTHORIZED_ESIA_LOGOUT = '_AUTHORIZED_ESIA_LOGOUT';
export const CALL_CALLBACK_ESIA = '_CALL_CALLBACK_ESIA';
export const GET_PROFILE_COMPANIES = '_GET_PROFILE_COMPANIES';
export const SET_COMPANY = '_SET_COMPANY';
export const LOAD_APPLICANT_LIST = '_LOAD_APPLICANT_LIST';
export const CREATE_REPRESENTATIVE = 'CREATE_REPRESENTATIVE';
export const EDIT_REPRESENTATIVE = '_EDIT_REPRESENTATIVE';
export const LOAD_REPRESENTATIVE_BY_ID = '_LOAD_REPRESENTATIVE_BY_ID';
export const ACCEPT_REPRESENTATIVE_BY_ID = '_ACCEPT_REPRESENTATIVE_BY_ID';

export const authorizedLogin = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_LOGIN, formValues => (formValues));
export const authorizedLogout = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_LOGOUT);
export const authorizedLogoutSuccessful = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_LOGOUT + SUCCESSFUL);
export const authorizedLoginSuccessful = createAction(AUTHORIZED_MODULE + AUTHORIZED_LOGIN + SUCCESSFUL, authorizedData => (authorizedData));
export const authorizedLoginFailed = createAction(AUTHORIZED_MODULE + AUTHORIZED_LOGIN + FAILED, formValues => (formValues));
export const authorizedCheck = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_CHECK);
export const authorizedCheckSuccess = createAction(AUTHORIZED_MODULE + AUTHORIZED_CHECK + SUCCESSFUL);

export const getESIAUrl = createDeferredAction(AUTHORIZED_MODULE + GET_ESIA_URL);
export const getESIAUrlSuccessful = createAction(AUTHORIZED_MODULE + GET_ESIA_URL + SUCCESSFUL);
export const getESIAUrlFailed = createAction(AUTHORIZED_MODULE + GET_ESIA_URL + FAILED);

export const callCallbackEsia = createDeferredAction(AUTHORIZED_MODULE + CALL_CALLBACK_ESIA);
export const callCallbackEsiaSuccessful = createAction(AUTHORIZED_MODULE + CALL_CALLBACK_ESIA + SUCCESSFUL);
export const callCallbackEsiaFailed = createAction(AUTHORIZED_MODULE + CALL_CALLBACK_ESIA + FAILED);

export const getProfileCompanies = createDeferredAction(AUTHORIZED_MODULE + GET_PROFILE_COMPANIES);
export const getProfileCompaniesSuccessful = createAction(AUTHORIZED_MODULE + GET_PROFILE_COMPANIES + SUCCESSFUL);
export const getProfileCompaniesFailed = createAction(AUTHORIZED_MODULE + GET_PROFILE_COMPANIES + FAILED);

export const setCompany = createDeferredAction(AUTHORIZED_MODULE + SET_COMPANY);
export const setCompanySuccessful = createAction(AUTHORIZED_MODULE + SET_COMPANY + SUCCESSFUL);
export const setCompanyFailed = createAction(AUTHORIZED_MODULE + SET_COMPANY + FAILED);

export const authorizedESIALogin = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_ESIA_LOGIN, formValues => (formValues));
export const authorizedESIALoginSuccessful = createAction(AUTHORIZED_MODULE + AUTHORIZED_ESIA_LOGIN + SUCCESSFUL, authorizedData => (authorizedData));
export const authorizedESIALoginFailed = createAction(AUTHORIZED_MODULE + AUTHORIZED_ESIA_LOGIN + FAILED, formValues => (formValues));

export const authorizedESIALogout = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_ESIA_LOGOUT);
export const authorizedESIALogoutSuccessful = createDeferredAction(AUTHORIZED_MODULE + AUTHORIZED_ESIA_LOGOUT + SUCCESSFUL);

export const forgotPassword = createDeferredAction(AUTHORIZED_MODULE + FORGOT_PASSWORD);
export const forgotPasswordSuccessful = createAction(AUTHORIZED_MODULE + FORGOT_PASSWORD + SUCCESSFUL);
export const forgotPasswordFailed = createAction(AUTHORIZED_MODULE + FORGOT_PASSWORD + FAILED);

export const refreshKeyCloak = createDeferredAction(AUTHORIZED_MODULE + REFRESH_KEY_CLOAK);
export const refreshKeyCloakSuccessful = createAction(AUTHORIZED_MODULE + REFRESH_KEY_CLOAK + SUCCESSFUL);
export const refreshKeyCloakFailed = createAction(AUTHORIZED_MODULE + REFRESH_KEY_CLOAK + FAILED);

export const loadTransportList = createDeferredAction(AUTHORIZED_MODULE + LOAD_TRANSPORT_LIST);
export const loadTransportListBegin = createAction(AUTHORIZED_MODULE + LOAD_TRANSPORT_LIST + BEGIN);
export const loadTransportListSuccessful = createAction(AUTHORIZED_MODULE + LOAD_TRANSPORT_LIST + SUCCESSFUL);
export const loadTransportListFailed = createAction(AUTHORIZED_MODULE + LOAD_TRANSPORT_LIST + FAILED);

export const loadOrganizationList = createDeferredAction(AUTHORIZED_MODULE + LOAD_ORGANIZATION_LIST);
export const loadOrganizationListSuccessful = createAction(AUTHORIZED_MODULE + LOAD_ORGANIZATION_LIST + SUCCESSFUL);
export const loadOrganizationListFailed = createAction(AUTHORIZED_MODULE + LOAD_ORGANIZATION_LIST + FAILED);
export const loadOrganizationListBegin = createAction(AUTHORIZED_MODULE + LOAD_ORGANIZATION_LIST + BEGIN);

export const loadNotification = createDeferredAction(AUTHORIZED_MODULE + LOAD_NOTIFICATION);
export const loadNotificationSuccessful = createAction(AUTHORIZED_MODULE + LOAD_NOTIFICATION + SUCCESSFUL);
export const loadNotificationFailed = createAction(AUTHORIZED_MODULE + LOAD_NOTIFICATION + FAILED);

export const loadNotificationTypes = createDeferredAction(AUTHORIZED_MODULE + LOAD_NOTIFICATION_TYPES);
export const loadNotificationTypesSuccessful = createAction(AUTHORIZED_MODULE + LOAD_NOTIFICATION_TYPES + SUCCESSFUL);
export const loadNotificationTypesFailed = createAction(AUTHORIZED_MODULE + LOAD_NOTIFICATION_TYPES + FAILED);

export const deleteNotification = createDeferredAction(AUTHORIZED_MODULE + DELETE_NOTIFICATION);
export const deleteNotificationSuccessful = createAction(AUTHORIZED_MODULE + DELETE_NOTIFICATION + SUCCESSFUL);
export const deleteNotificationFailed = createAction(AUTHORIZED_MODULE + DELETE_NOTIFICATION + FAILED);

export const markAllNotification = createDeferredAction(AUTHORIZED_MODULE + MARK_ALL);
export const markAllNotificationSuccessful = createAction(AUTHORIZED_MODULE + MARK_ALL + SUCCESSFUL);
export const markAllNotificationFailed = createAction(AUTHORIZED_MODULE + MARK_ALL + FAILED);

export const loadRepresentativeList = createDeferredAction(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_LIST);
export const loadRepresentativeListBegin = createAction(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_LIST + BEGIN);
export const loadRepresentativeListSuccessful = createAction(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_LIST + SUCCESSFUL);
export const loadRepresentativeListFailed = createAction(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_LIST + FAILED);

export const loadApplicantList = createDeferredAction(AUTHORIZED_MODULE + LOAD_APPLICANT_LIST);
export const loadApplicantListBegin = createDeferredAction(AUTHORIZED_MODULE + LOAD_APPLICANT_LIST + BEGIN);
export const loadApplicantListSuccessful = createAction(AUTHORIZED_MODULE + LOAD_APPLICANT_LIST + SUCCESSFUL);
export const loadApplicantListFailed = createAction(AUTHORIZED_MODULE + LOAD_APPLICANT_LIST + FAILED);

export const createRepresentative = createDeferredAction(AUTHORIZED_MODULE + CREATE_REPRESENTATIVE);
export const createRepresentativeSuccessful = createAction(AUTHORIZED_MODULE + CREATE_REPRESENTATIVE + SUCCESSFUL);
export const createRepresentativeFailed = createAction(AUTHORIZED_MODULE + CREATE_REPRESENTATIVE + FAILED);

export const loadRepresentativeById = createDeferredAction(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_BY_ID);
export const loadRepresentativeByIdSuccessful = createAction(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_BY_ID + SUCCESSFUL);
export const loadRepresentativeByIdFailed = createAction(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_BY_ID + FAILED);
export const loadRepresentativeByIdBegin = createAction(AUTHORIZED_MODULE + LOAD_REPRESENTATIVE_BY_ID + BEGIN);

export const editRepresentative = createDeferredAction(AUTHORIZED_MODULE + EDIT_REPRESENTATIVE);
export const editRepresentativeSettingSuccessful = createAction(AUTHORIZED_MODULE + EDIT_REPRESENTATIVE + SUCCESSFUL);
export const editRepresentativeSettingFailed = createAction(AUTHORIZED_MODULE + EDIT_REPRESENTATIVE + FAILED);

export const acceptRepresentative = createDeferredAction(AUTHORIZED_MODULE + ACCEPT_REPRESENTATIVE_BY_ID);
export const acceptRepresentativeSettingSuccessful = createAction(AUTHORIZED_MODULE + ACCEPT_REPRESENTATIVE_BY_ID + SUCCESSFUL);
export const acceptRepresentativeSettingFailed = createAction(AUTHORIZED_MODULE + ACCEPT_REPRESENTATIVE_BY_ID + FAILED);
